import { Matrix3 } from "three";
import CanvasInputListenerModeEnum from "../enums/CanvasInputListenerModeEnum";
import CommandIdEnum from "../enums/CommandIdEnums";
import RaycastIntersection from "../logic/RaycastIntersection";
import CommandStack from "../logic/CommandStack";
import ICanvasInputListener from "../logic/ICanvasInputListener";
import Document from "../model/document/Document";
import SceneObjectData from "../model/sceneObjectData/SceneObjectData";
import ChecklistItemData from "../model/sceneObjectData/ChecklistItemData";
import GeometryMoveEditCmd from "./GeometryMoveEditCmd";

/**
 * Movement constrained to scene geometry surfaces. Raycasts against all target
 * objects and snaps both position and normal to the hit surface.
 */
export default class GeometryFreeMoveCmd extends GeometryMoveEditCmd {

    constructor(
        commandStack: CommandStack,
        canvasInputListener: ICanvasInputListener,
        document: Document,
    ) {
        super(commandStack, canvasInputListener, document);
        this.id = CommandIdEnum.GeometryFreeMove;
        this.commandNameResourceKey = 'command.geometryFreeMove.title';
        this.initialPrompResourceKey = 'command.geometryFreeMove.prompt';
    }

    protected override setupRaycastTarget(): void {
        // Reset to default targets (full model geometry) so the checklist item
        // can snap to any BIM surface, not just the narrow set set by SelectCmd.showHandles.
        this.canvasInputListener.resetTargetObjects();
        this.canvasInputListener.setRaycastMode(CanvasInputListenerModeEnum.RAYCAST_TARGET_OBJECTS);
    }

    protected override enrichPreviewData(previewData: SceneObjectData, raycastResult: RaycastIntersection): void {
        if (!(previewData instanceof ChecklistItemData) || !raycastResult.normalInWcs) return;
        const toLocal = new Matrix3().setFromMatrix4(this.parentWorldMatrix.clone().invert());
        previewData.normal = raycastResult.normalInWcs.clone().applyMatrix3(toLocal).normalize();
    }
}
